import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Gauge, Wallet, HandCoins } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import Semaforo from "./Semaforo";
import Statements from "./Statements";
import Receipts from "./Receipts";

export default function AccountsReceivable() {
  const { can } = useAuth();
  const tabs = [
    can("statements:view") && { v: "semaforo", label: "Semáforo", Icon: Gauge, El: Semaforo },
    can("statements:view") && { v: "estados", label: "Estados de cuenta", Icon: Wallet, El: Statements },
    can("receipts:view") && { v: "recibos", label: "Recibos de caja", Icon: HandCoins, El: Receipts },
  ].filter(Boolean);
  const [tab, setTab] = useState(tabs[0]?.v || "semaforo");
  if (tabs.length === 0) return null;

  return (
    <div className="space-y-5">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="rounded-sm" data-testid="cxc-tabs">
          {tabs.map((t) => (
            <TabsTrigger key={t.v} value={t.v} className="rounded-sm gap-2 text-xs" data-testid={`cxc-tab-${t.v}`}>
              <t.Icon className="h-4 w-4" />{t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((t) => (
          <TabsContent key={t.v} value={t.v} className="mt-5">
            <t.El />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
